/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import * as ResourcesConstants from 'constants/ResourcesConstants'
import { getAuthorizationHeader } from 'utils/Helpers'
import { RequestContentType } from 'utils/Helpers'
import { encodeQueryData } from 'utils/Helpers'

const CompanyAPI = Marty.createStateSource({
  id: 'CompanyAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  fetchCompany(companyId) {
    return this.get({
      url: `/companies/${ companyId }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchCompanyListForOrgId(orgId) {
    return this.get({
      url: `/organizations/${ orgId }/companies`,
      headers: getAuthorizationHeader()
    })
  },

  fetchCompaniesByIds(companyIds) {
    const query = companyIds.map(companyId => `companyId=${ companyId }`).join('&')
    return this.get({
      url: `/companies?${ query }`,
      headers: getAuthorizationHeader()
    })
  },

  updateCompany(companyId, companyParams) {
    return this.patch({
      url: `/companies/${ companyId }`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(companyParams)
    })
  }

})

export default CompanyAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/CompanyAPI.js